import { EntityChildsContext } from "app/private/entity/entityWithChilds/model/EntityChildsContext";

export class Organization {
    organizationCode: string;
    description: string;
    descriptionExt: string;
    imagen: string;    
    subscriptions: {};
    UrlImage: string;
    creado: string;
    modificado: string;
    fechaCreacion: Date;
    fechaActualizacion: Date;
};



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/classes/organization.class.ts